import { COLORS } from "@/constants/Colors/colors";
import { Button, InputAdornment, TextField } from "@mui/material";
import useCustomMutation from "@/hooks/useCustomMutation";
import Modal from "@shared/Modal/Modal";
import { notifySuccess } from "@shared/Toast/toast";
import { useQueryClient } from "@tanstack/react-query";
import React, { useState } from "react";
import { HashLoader } from "react-spinners";
import PropTypes from "prop-types";

export const EditBar = ({ open, setOpen, id, body }) => {
  const [message, setMessage] = useState(body);
  const [submitted, setSubmitted] = useState(false);
  const queryClient = useQueryClient();
  const { mutate, isPending } = useCustomMutation({
    url: `bar/updateMessage`,
    onSuccess: () => {
      setOpen(false);
      notifySuccess("تم تعديل البانر بنجاح");
      queryClient.invalidateQueries(["bar"]);
    },
  });
  return (
    <Modal open={open} closeFn={() => setOpen(false)}>
      <TextField
        label="العنوان"
        type="text"
        value={message}
        onChange={(e) => {
          setMessage(e.target.value);
        }}
        error={!message && submitted}
        helperText={!message && submitted && "يجب إضافة عنوان للبانر"}
        sx={{
          marginTop: 2,
          width: "70%",
          "& .MuiFormLabel-root.Mui-focused": {
            color: "#2f8bc8",
          },
          "& label": {
            left: "unset",
            right: "1.75rem",
            transformOrigin: "right",
            fontSize: "0.8rem",
            color: "#2f8bc8",
          },
          "& legend": {
            textAlign: "right",
            fontSize: "0.6rem",
          },
          direction: "rtl",
        }}
        InputProps={{
          startAdornment: <InputAdornment position="end"></InputAdornment>,
        }}
      />
      <Button
        onClick={() => {
          setSubmitted(true);
          if (!message) return;
          mutate({
            id: String(id),
            body: message,
          });
        }}
        sx={{
          bgcolor: COLORS.PRIMARY.MAIN,
          color: COLORS.WHITE,
          marginTop: 2,
          "&:hover": { bgcolor: COLORS.PRIMARY.MAIN },
        }}
      >
        {isPending ? <HashLoader color={COLORS.WHITE} size={20} /> : "تعديل"}
      </Button>
    </Modal>
  );
};

EditBar.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.bool,
  id: PropTypes.number,
  body: PropTypes.string,
};
